/* eslint import/prefer-default-export: "off" */
/* eslint no-use-before-define: "off" */

declare const mixpanel: any;

export { track };

const track = ({
  eventName,
  trackingParams,
}: {
  eventName: string;
  trackingParams: any;
}) => {
  if (typeof mixpanel !== 'undefined') {
    const distinctId = 'newsletter-reader';
    mixpanel.people.set({
      $distinct_id: distinctId,
    });
    mixpanel.identify(distinctId);
    mixpanel.track(eventName, trackingParams);
  } else {
    console.log(
      JSON.stringify({
        eventName,
        trackingParams,
      })
    );
  }
};
